import React, { useEffect, useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { Typography } from '@material-ui/core'

import SubmitDialog from 'app/componentV4/Dialog/SubmitDialog'

import { SECONDARY } from 'app/constants/input'
import { TYPE_SELECTED } from 'app/constants/subscriberCRM'
import { useAction } from '../../subscribersV4/actions/useAction'

const SubscriberExportCSV = (props) => {
  const { selectedIds = [], totalSelectedCount = 0 } = props
  const { formatMessage } = useIntl()

  const classForExport = totalSelectedCount ? 'pr-5' : null

  const {
    state: { isLoadingExport },
    exportSubscribers,
    countSubscribersStatus,
  } = useAction(formatMessage)

  const [isOpen, setIsOpen] = useState(false)

  const handleOpen = () => {
    setIsOpen(true)
  }

  const handleClose = useCallback(() => {
    setIsOpen(false)
  }, [])

  const handleExport = useCallback(async () => {
    await exportSubscribers(TYPE_SELECTED, selectedIds, [])
    handleClose()
  }, [exportSubscribers, handleClose])

  const fetchcountSubscribersStatus = useCallback(() => {
    countSubscribersStatus()
  }, [countSubscribersStatus])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(fetchcountSubscribersStatus, [])

  return (
    <div className={classForExport}>
      <Typography
        className="text-14 text-secondary font-500 cursor-pointer"
        onClick={() => handleOpen()}
      >
        {formatMessage({
          id: 'teamMembers.table.action.exportCSV.label',
        })}
      </Typography>

      <SubmitDialog
        id="dialog-export-csv-team-member"
        open={isOpen}
        type={SECONDARY}
        title={formatMessage({
          id: 'exportCSV.title',
        })}
        submitText={formatMessage({
          id: 'action.export',
        })}
        onSubmit={async () => {
          await handleExport()
        }}
        closeText={formatMessage({
          id: 'text.close',
        })}
        onClose={() => handleClose()}
        disabledSubmit={isLoadingExport}
        isLoading={isLoadingExport}
      />
    </div>
  )
}

SubscriberExportCSV.propTypes = {
  selectedIds: PropTypes.array,
  totalSelectedCount: PropTypes.number,
}

export default SubscriberExportCSV
